import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { HrDashboardService } from '../../../services/hr-dashboard.service';

@Component({
  selector: 'app-critical-teams-widget',
  standalone: false,
  templateUrl: './critical-teams-widget.component.html',
  styleUrl: './critical-teams-widget.component.scss'
})
export class CriticalTeamsWidgetComponent implements  OnChanges{
  teams: any[] = [];
  colors = ['#EB5757', '#F2994A', '#F2C94C', '#27AE60', '#2F80ED']; 
  @Input() tenantId!: number;
  constructor(private hrDashboardService: HrDashboardService) {}


  ngOnChanges(): void {
    if (this.tenantId) {
      this.loadCriticalTeams();
    }
  }

  private loadCriticalTeams() {

    this.hrDashboardService.getCriticalTeams(this.tenantId).subscribe((data: any[]) => {
      this.teams = data.map((team, index) => ({
        name: team.teamName,
        value: team.scorePercentage,
        color: this.colors[index % this.colors.length]
      }));
    });
  }


}
